import { Injectable } from '@angular/core';

import { ApAnalyticsService, FormFieldValue, FormStepAnalyticsData } from '@ap/analytics';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService extends ApAnalyticsService {
    private readonly product = 'Hypotheek renteoverzicht';

    sendValueUpdate(key: string, value: any): void {
        this.push(new FormStepAnalyticsData(this.product, 'Angular', `${this.product} value`, 1, null, [new FormFieldValue(key, value)]));
    }

    sendLtvCalculation(mortgageAmount: string, purchasePrice: string): void {
        const formFieldValues = [
            new FormFieldValue('mortgage amount', mortgageAmount, AnalyticsService.anonymizers.amount),
            new FormFieldValue('purchase price', purchasePrice, AnalyticsService.anonymizers.amount)
        ];
        this.push(new FormStepAnalyticsData(this.product, 'Angular', `${this.product} value`, 1, null, formFieldValues));
    }
}
